var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-stat2 bordered" }, [
    _c("div", { staticClass: "display" }, [
      _c("div", { staticClass: "number" }, [
        _c("small", { style: { color: _vm.colorTitle } }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c(
              "h3",
              {
                staticStyle: { "font-size": "25px" },
                style: { color: _vm.colorValueField },
              },
              [_c("span", [_vm._v(_vm._s(_vm.getValueField()))])]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              style: { color: _vm.colorPerc(), visibility: _vm.visibilityPerc },
            },
            [
              _c("i", { class: _vm.iconPerc() }),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-weight": "600", "margin-left": "2px" } },
                [_vm._v(_vm._s(Math.round(Math.abs(_vm.percentage), 2)) + "%")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "10px",
                    color: "gray",
                    "font-weight": "600",
                  },
                },
                [_vm._v(" (em relação ao mês anterior)")]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "table", float: "right" } }, [
        _c("div", { staticStyle: { display: "table-row" } }, [
          _c("div", { staticClass: "icon" }, [
            _c("i", {
              class: _vm.iconMain,
              style: { color: _vm.colorIconMain },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-circle btn-icon-only btn-default",
            staticStyle: {
              height: "27px",
              padding: "2px 6px 2px",
              width: "27px",
              "margin-top": "17px",
            },
            on: {
              click: function ($event) {
                return _vm.AbrirDetalhes()
              },
            },
          },
          [
            _c("i", {
              staticClass: "fa fa-search",
              style: { color: _vm.colorIconSearch },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }